export const FETCH__LOAN = 'FETCH__LOAN';
export const FETCH__LOAN__SUCCESS = 'FETCH__LOAN__SUCCESS';
export const FETCH__LOAN__FAIL = 'FETCH__LOAN__FAIL';